
const CLIPBOARD_HELPER = {
    copy(value) {
        navigator.clipboard.writeText(value)
    },
}

export default CLIPBOARD_HELPER
